module.exports = __webpack_public_path__ + "static/media/leftArrow.94bd4e11.svg";